




import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'

@Component
export default class CheckboxGroupFilter extends mixins(FilterComponentMixin) {}
